import script from "./footer-legal-links.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer-legal-links.vue?vue&type=script&setup=true&lang=ts"

import "./footer-legal-links.vue?vue&type=style&index=0&id=121e1ea1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121e1ea1"]])

export default __exports__